module.exports = __webpack_public_path__ + "img/lanshiqrcode.6dc87a93.png";